import BaseHelper from './BaseHelper'
import ResizeObserver from 'resize-observer-polyfill'

function computeArea(rect) {
  return rect.width * rect.height
}

export default class SizeHelper extends BaseHelper {
  static configName = 'SizeHelper'

  static init() {
    let self = this
    this.size = this.$root.getBoundingClientRect()
    const resizeObserver = new ResizeObserver(() => {
      let newSize = self.$root.getBoundingClientRect()
      if (computeArea(newSize) > 0 && JSON.stringify(self.size) !== JSON.stringify(newSize)) {
        setTimeout(
          () => {
            self.size = newSize
            self._draw()
          },
          self.$root.classList.contains('is-printable') ? 1000 : 0
        )
      }
    })

    resizeObserver.observe(self.$root.parentNode)
  }
  static beforeDraw() {
    this.size = this.$root.getBoundingClientRect()
  }
  static draw() {}
  static afterDraw() {}
}
